import { Message, MessageAndIdModel } from "../../../domain/model/Auth";
import { Category } from "../../../domain/model/Category";
import {
  GetRandomQuestionRequestModel,
  Question,
  QuestionGiveRatingRequestModel,
  SubcategoryNumberOfQuestionsModel,
} from "../../../domain/model/Question";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { QuestionRepository } from "./QuestionRepository";

export class QuestionRepositoryImpl implements QuestionRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  getNumberOfRemainingQuestions(
    categoriesId: Array<string>
  ): Promise<Response<Array<Array<SubcategoryNumberOfQuestionsModel>>>> {
    return this.apiService.getNumberOfRemainingQuestions(categoriesId);
  }
  getRandomQuestion(
    getRandomQuestionRequestModel: GetRandomQuestionRequestModel
  ): Promise<Response<Question>> {
    return this.apiService.getRandomQuestion(getRandomQuestionRequestModel);
  }
  giveRating(
    questionId: string,
    giveRatingModel: QuestionGiveRatingRequestModel
  ): Promise<Response<Message>> {
    return this.apiService.giveRating(questionId, giveRatingModel);
  }
  giveAnswer(
    questionId: string,
    isCorrect: boolean
  ): Promise<Response<Message>> {
    return this.apiService.giveAnswer(questionId, isCorrect);
  }
}
